import React from 'react';
import './CustomLoader.css'; // Make sure to create this CSS file

const CustomLoader = () => {
    return (
        <div className="custom-loader-container">
            <div className="custom-loader"></div>
        </div>
    );
};

export default CustomLoader;
